<template>
  <div class="modal-card confirm-modal">
    <div class="modal-header">
      <p class="modal-header-text">
        {{ $t('exchange.allow_exchange') }}
      </p>
      <div
        class="modal-header-close-btn"
        @click="$parent.close()"
      >
        <img src="/static/svg/close-symbol.svg">
      </div>
    </div>
    <div class="modal-body">
      <div class="modal-content">
        <img src="/static/gif/exchange-allow-animate.gif">
        <div class="token-info">
          <div class="token-name-img">
            <img :src="`/static/token/normal/${code.toLowerCase()}.svg`">
          </div>
          <div class="token-name-lable">
            <div class="token-name-lable-code">
              {{ code }}
            </div>
            <div class="token-name-lable-fullname">
              {{ name }}
            </div>
          </div>
        </div>
        <div class="text-info">
          <span
            v-html="allowDetail"
          />
        </div>
        <div class="address-info">
          <p>{{ $t('exchange.your_address_is') }}</p>
          <p class="address-info-address">{{ userAddress }}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        class="button cancle-btn"
        type="button"
        @click="$parent.close()"
      >
        <img
          :src="`/static/svg/arrow-back.svg`"
          class="arrow-back"
        >
        <span style="margin-left: 10px;">
          {{ $t('messages.back') }}
        </span>
      </button>
      <button
        class="button confirm-btn"
        @click="$emit('onConfirm')"
      >
        {{ $t('exchange.approve') }}
      </button>
    </div>
  </div>
</template>

<script>
// ['code', 'name', 'userAddress']
export default {
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    userAddress: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      allowDetail: this.$t('exchange.allow_exchange_detail', ['<span style="color: #0564c4;font-weight: bold;">' + this.code + '</span>'])
    }
  }
}
</script>
<style scoped>
  .confirm-modal {
    float: left;
    width: 530px;
    background-color: #ffffff;
    border-radius: 5px;
  }
  .modal-header {
    float: left;
    width: 100%;
    height: 62px;
    background-color: #0559af;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-header-text {
    font-family: Roboto;
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    color: #ffffff;
  }
  .modal-header-close-btn {
    position: absolute;
    top: 15px;
    right: 19px;
  }
  .modal-header-close-btn {
    cursor: pointer;
  }
  .modal-body {
    float: left;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-content {
    width: 100%;
    float: left;
    padding: 40px 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .token-info{
    float: left;
    padding: 0px 15px;
    width: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 35px;
  }
  .token-name-img {
    float: left;
    height: 40px;
    width: 40px;
    padding: 5px;
  }
  .token-name-lable {
  float: left;
  margin-left: 10px;
  }
  .token-name-lable-fullname {
    font-family: Roboto;
    font-size: 11px;
    font-weight: 300;
    color: #646464;
  }
  .token-name-lable-code {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
  }
  .text-info{
    float: left;
    padding: 0px 15px;
    width: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    text-align: center;
  }
  .address-info{
    float: left;
    padding: 0px 15px;
    width: 100%;
    text-align: center;
    margin: 30px 0;
  }
  .address-info-address {
    color: #0564c4;
    margin-top: 5px;
  }
  .modal-footer {
    float: left;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 3px solid #dfdfdf;
    height: 70px;
    padding: 0 20px;
  }
  .confirm-btn {
    width: 108px;
    height: 40px;
    border-radius: 2px;
    border: 0px;
    background-color: #3eaf34;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    margin-left: 5px;
    font-family: Roboto;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 0.4px;
    color: #ffffff;
  }
  .cancle-btn {
    width: 108px;
    height: 40px;
    border: 0px;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 0.4px;
    color: #454545;
  }
  .arrow-back {
    width: 16px;
    height: 16px;
  }
  @media only screen and (max-width: 768px) {
    .confirm-modal {
      width: 100%;
      /* height: 530px; */
    }
    .modal-content {
      padding: 40px 0px;
      margin: 10px 0;
    }
    .token-rate {
      float: left;
      width: 100%;
      text-align: center;
    }
    .is-mobile-margin {
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AllowExchangeModal.vue